// this file is generated by update_shopify_store_data.py at 2025-12-03 20:29:35.750018
var courses = [];